<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_IS_NDT'
        )
      }"
    >
      <select
        :disabled="$parent.$parent.projectDisabled"
        v-model="project.UF_IS_NDT"
        class="sel-dropdown i-main-style i-wid-13"
      >
        <option :value="1">Да</option>
        <option :value="0">Нет</option>
      </select>
      <div class="error-text">
        {{ $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_IS_NDT") }}
      </div>
    </div>
    <div class="" v-if="project.UF_IS_NDT">
      <br /><br />
      <div
        class="form-group"
        v-bind:class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_TECHNOLOY_NDT_ID_ARR'
          )
        }"
      >
        <label>НДТ</label>
        <!--   начало блока подсказки   -->
        <div class="info-holder-container">
          <Multiselect
            label="NAME"
            class="i-main-style-rp"
            style="
                      width: 98%;
                      min-height: 70px;
                      "
            :limit="3"
            :limitText="filterItemText"
            track-by="ID"
            v-model="project.UF_TECHNOLOY_NDT_ID_ARR"
            :options="getListSpNdt()"
            :multiple="true"
            placeholder=""
          />
        </div>
      </div>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_TECHNOLOY_NDT_ID_ARR"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "uf_is_ndt",
  computed: {
    ...mapGetters(["directory", "project"])
  },
  components: {
    Multiselect
  },
  methods: {
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    getListSpNdt() {
      let returnList = [];
      let versionListNum =
        this.$parent.project.UF_SETTING.VERSION_SP_NDT > 0
          ? this.$parent.project.UF_SETTING.VERSION_SP_NDT
          : 1;

      if (
        this.$parent.project.UF_SETTING.HIDE_NDT_ID &&
        this.$parent.project.UF_SETTING.HIDE_NDT_ID.length
      ) {
        let allIdNTD = [];
        this.directory.sp_ndt.forEach(function(el) {
          allIdNTD.push(el.ID);
        }, this);

        let returnListId = allIdNTD.filter(
          x => !this.$parent.project.UF_SETTING.HIDE_NDT_ID.includes(x)
        );

        this.directory.sp_ndt.forEach(function(el) {
          if (
            this.inArray(versionListNum, el.VERSION) &&
            this.inArray(el.ID, returnListId)
          ) {
            returnList.push(el);
          }
        }, this);
      } else {
        this.directory.sp_ndt.forEach(function(el) {
          if (this.inArray(versionListNum, el.VERSION)) {
            //returnList = this.directory.sp_ndt;
            returnList.push(el);
          }
        }, this);
      }
      return returnList;
    }
  }
};
</script>

<style scoped></style>
